"use client";
import {
  FeatureControlPropertiesWithSegmentation,
  FeatureControlPropertiesWithSegmentationSchema,
  useFeatureControl,
} from "@ctv/shared-core/src";
import { useMemo } from "react";
import { useAuth } from "../auth";

export default function useFeatureControlSegmentation(fcKey: string) {
  const { user } = useAuth();
  const { enabled, properties } =
    useFeatureControl<FeatureControlPropertiesWithSegmentation>(fcKey);

  return useMemo(() => {
    // if the feature control not contains the properties, return enabled and undefined
    if (
      properties === undefined ||
      properties === null ||
      Object.keys(properties).length === 0
    ) {
      return { enabled, properties: undefined };
    }

    // if feature control contains the properties, validate the properties
    const parsed =
      FeatureControlPropertiesWithSegmentationSchema.safeParse(properties);

    if (!enabled || !parsed.success || !user) {
      return { enabled, properties };
    }

    const { key, eligible, global } = parsed.data;

    if (!eligible) {
      return { enabled, properties };
    }

    if (global === "false" || typeof global === "undefined") {
      const userProperties = user[key ? key : "email"];
      if (!eligible.includes(userProperties)) {
        return { enabled: false, properties };
      }
    }

    return { enabled, properties };
  }, [user, enabled, properties]);
}
